import React from 'react';

const VectorEllipses = ({ color = '#0077C8' }) => {
  return (
    <svg
      width='16'
      height='6'
      viewBox='0 0 16 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.3226 3C10.3226 4.38194 9.28387 5.5 8 5.5C6.71613 5.5 5.67742 4.38194 5.67742 3C5.67742 1.61806 6.71613 0.5 8 0.5C9.28387 0.5 10.3226 1.61806 10.3226 3ZM13.6774 0.5C12.3935 0.5 11.3548 1.61806 11.3548 3C11.3548 4.38194 12.3935 5.5 13.6774 5.5C14.9613 5.5 16 4.38194 16 3C16 1.61806 14.9613 0.5 13.6774 0.5ZM2.32258 0.5C1.03871 0.5 0 1.61806 0 3C0 4.38194 1.03871 5.5 2.32258 5.5C3.60645 5.5 4.64516 4.38194 4.64516 3C4.64516 1.61806 3.60645 0.5 2.32258 0.5Z'
        fill={color}
      />
    </svg>
  );
};

export default VectorEllipses;
